<template>
  <div class="page-shake" v-show="imgReady">
    <img class="radiate animated fadeIn" id="top" src="@/assets/img/radiate.png">
    <img class="logo animated bounceIn" src="@/assets/img/shake_logo.png">
    <div class="phone-box fx fx-center">
      <img class="phone" :class="shake ? 'animated wobble' : 'animated bounceInUp'" src="@/assets/img/phone.png">
    </div>
    <img class="get-btn animated fadeIn" @click="onRewardTap" src="@/assets/img/shake_button.png">
    <div class="mask" v-show="showDialog"></div>
    <!-- 礼物弹窗 -->
    <div class="goods-dialog" v-show="showDialog">
      <div class="animated fadeInDown">
        <img src="@/assets/img/shake_box.png">
        <div class="goods-box">
          <p class="name text-center">{{pageData.goodsName}}</p>
          <div class="goods">
              <img class="pic" :style="{width: picSize, height: picSize,}" :src="pageData.goodsUrlIco">
              <img class="bg bg-f" src="@/assets/img/box1.png">
              <img class="bg bg-e" src="@/assets/img/box2.png">
          </div>
          <p class="txt text-center">
            {{pageData.wishRemarks}}
          </p>
        </div>
        <img class="check-btn" @click="onDetailTap" src="@/assets/img/shake_button.png">
      </div>
    </div>
    <img class="star star1 animated fadeIn" src="@/assets/img/star.png">
    <img class="star star2 animated fadeIn" src="@/assets/img/star.png">
    <img class="star star3 animated fadeIn" src="@/assets/img/star.png">
    <img class="star star4 animated fadeIn" src="@/assets/img/star.png">
  </div>
</template>

<script>

export default {
  data () {
    return {
      imgReady: false,
      shake: false,
      showDialog: false,
      params: {
        gameId: '',
        token: ''
      },
      pageData: {},
      picSize: ''
    }
  },
  created () {
    let queryParams = this.$route.query
    this.params.gameId = queryParams.id
    this.params.token = this.$util.storageGet('local', 'token')
    this.picSize = document.documentElement.clientWidth * 0.55 - 20 + 'px'
    this.preloadImg()
  },
  methods: {
    // 资格验证
    passCheck (params) {
      return this.$http.post('/olvp/passCheck', 'passCheck', params, false, false, false, false)
    },
    // 抽奖
    getRewards (params) {
      return this.$http.post('/olvp/getRewards', 'getRewards', params, false, false, false, false)
    },
    // 图片预加载
    preloadImg () {
      let imgs = [
        require('@/assets/img/radiate.png'),
        require('@/assets/img/shake_logo.png'),
        require('@/assets/img/box1.png'),
        require('@/assets/img/box2.png'),
        require('@/assets/img/phone.png'),
        require('@/assets/img/shake_bg.jpg'),
        require('@/assets/img/shake_box.png'),
        require('@/assets/img/shake_button.png'),
        require('@/assets/img/shake_top.png'),
        require('@/assets/img/star.png')
      ]

      // this.num = imgs.length

      for (let img of imgs) {
        let image = new Image()
        image.onload = () => {
          this.count++
          // let percentNum = Math.floor(this.count / this.num * 100)
          // this.percent = `${percentNum}%`
        }
        image.src = img
        if (image.length === this.count) {
          this.imgReady = true
        }
      }
    },
    // 点击抽奖
    onRewardTap () {
      this.passCheck(this.params).then((r) => {
        if (r.success && r.content.returnCode === 'pass') {
          const params = {
            gameId: this.params.gameId,
            token: this.params.token,
            passNo: r.content.passNo
          }
          this.shake = true
          this.getRewards(params).then((d) => {
            if (d.success) {
              this.pageData = d.content.rewardDetail.rewardData
              setTimeout(() => {
                this.showDialog = true
              }, 1500)
            }
          })
        } else {
          this.$cux.toast(r.errorMessage)
        }
      })
    },
    onDetailTap () {
      this.$router.replace(`/productDetail?goodsId=${this.pageData.goodsId}`)
    }
  }
}
</script>

<style lang="scss">
  .page-shake {
    width: 100%;
    height: 100%;
    background: url('../../../assets/img/shake_bg.jpg') no-repeat;
    background-size: 100% 100%;
    padding-top: 50px;
    .star {
      position: absolute;
      animation-iteration-count: infinite;
      -webkit-animation-iteration-count: infinite;
      animation-duration: 1.2s;
      -webkit-animation-duration: 1.2s;
      &.star1 {
        width: 30px;
        height: 30px;
        left: 20px;
        bottom: 25%;
        animation-delay: 1.5s;
        -webkit-animation-delay: 1.5s;
      }
      &.star2 {
        width: 25px;
        height: 25px;
        left: 30px;
        bottom: 8%;
        animation-delay: 2.5s;
        -webkit-animation-delay: 2.5s;
      }
      &.star3 {
        width: 25px;
        height: 25px;
        right: 15px;
        bottom: 30%;
        animation-delay: 2s;
        -webkit-animation-delay: 2s;
      }
      &.star4 {
        width: 30px;
        height: 30px;
        right: 20px;
        bottom: 10%;
        animation-delay: 3s;
        -webkit-animation-delay: 3s;
      }
    }
    .mask {
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, .8);
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 9;
    }
    .goods-dialog {
      color: #FFEC00;
      width: 100%;
      height: auto;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 99;
      .animated {
        animation-duration: .6s;
        -webkit-animation-duration: .6s;
      }
      .check-btn {
        width: 60%;
        position: absolute;
        bottom: 10px;
        left: 50%;
        transform: translate(-50%, 0);
      }
      .goods-box {
        width: 70%;
        position: absolute;
        top: 27%;
        left: 50%;
        transform: translate(-50%, 0);
        .name {
          margin: 15px 0 8px 0;
        }
        .txt {
          margin-top: 15px;
          line-height: 20px;
        }
        .goods {
          width: 55vw;
          height: 55vw;
          margin: 0 auto;
          position: relative;
          .bg {
            position: absolute;
            &.bg-f {
              z-index: 1;
            }
            &.bg-e {
              z-index: 2;
              animation: twinkling 1.5s ease infinite 0.6s;
            }
          }
          .pic {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 100%;
            height: 100%;
            transform: translate(-50%, -50%);
            border-radius: 15px;
          }
        }
      }
    }

    .radiate {
      width: 100%;
      height: auto;
      position: absolute;
      top: -10px;
      -webkit-animation-delay: .8s;
      animation-delay: .8s;
    }

    .logo {
      width: 80%;
      margin: 0 auto;
      -webkit-animation-delay: .8s;
      animation-delay: .8s;
    }
    .phone-box {
      z-index: 1;
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 42%;
      transform: translate(-50%, 0);
      .phone {
        width: 80%;
        height: 100%;
        -webkit-animation-delay: .8s;
        animation-delay: .8s;
        &.wobble {
          -webkit-animation-delay: .2s;
          animation-delay: .2s;
        //   animation-iteration-count: 2;
        // -webkit-animation-iteration-count: 2;
        }
         &.bounceInUp {
          -webkit-animation-delay: .8s;
          animation-delay: .8s;
        }
      }
    }
    .get-btn {
      z-index: 2;
      width: 70%;
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translate(-50%, 0);
      animation-delay: 1.5s;
      -webkit-animation-delay: 1.5s;
      animation-duration: .3s;
      -webkit-animation-duration: .3s;
    }

    @keyframes twinkling {
      0% {
        z-index: 2;
      }

      100% {
        z-index: 0;
      }
    }
  }
</style>
